"use client";

import React from "react";
import { Empty, Skeleton, Spin } from "antd";
import BlogPost from "./BlogPost";

import InfiniteScroll from "react-infinite-scroller";
import SkeletonImage from "antd/es/skeleton/Image";
import { useBlog } from "./BlogContext";
import { loadFunc } from "../common";

const Scroller = () => {
  const {
    hasNext,
    setHasNext,
    nextUrl,
    setNextUrl,
    blogPosts,
    setBlogPosts,
    checkedTags,
    count,
    setCount,
    search,
  } = useBlog();

  const handleLoadMore = async () => {
    loadFunc(
      hasNext,
      nextUrl,
      search,
      checkedTags,
      blogPosts,
      setBlogPosts,
      setHasNext,
      setNextUrl,
      setCount
    );
  };

  return (
    <InfiniteScroll
      pageStart={0}
      loadMore={handleLoadMore}
      hasMore={hasNext}
      loader={
        <>
          <div
            className="hidden md:grid md:grid-cols-3 gap-10 mt-12 pb-5"
            key={"loader"}
          >
            {Array.from({ length: 3 }).map((_, idx) => (
              <div key={idx} className="rounded-b-xl shadow-xl h-[430px]">
                <SkeletonImage active className="w-full h-[240px]" />
                <div className="p-5">
                  <Skeleton active paragraph={{ rows: 5 }} title={false} />
                </div>
              </div>
            ))}
          </div>
          <div key="spinner" className="flex justify-center">
            <Spin />
          </div>
        </>
      }
    >
      <div className="flex mt-20 justify-between">
        <p className="text-3xl">Most recent posts </p>
        <p className="text-ginger-gray-100 text-lg font-bold">
          {count} results
        </p>
      </div>
      {blogPosts.length === 0 && !hasNext ? (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={
            <span>
              It looks like we don&apos;t have any content matching your search.
              Please try adjusting your search criteria.
            </span>
          }
        />
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 mt-12">
          {blogPosts.map((post: any) => (
            <BlogPost {...post} key={post.slug} />
          ))}
        </div>
      )}
    </InfiniteScroll>
  );
};

export default Scroller;
